import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const Flex = styled.div`
	display: flex;
	gap: 20px;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 20px;
	gap: 20px;
`;

export const TableTitle = styled.h3`
	width: 100%;
	color: ${Colors.darkBlue};
	margin: 20px 4px 10px;
`;

export const QueueTableWrapper = styled.div`
	opacity: ${(props) => (props.show ? 1 : 0.1)};
	overflow: hidden;
	height: ${(props) => (props.show ? 'fit-content' : '100px')};
	transition: all 0.3s;
`;

export const ShowArrow = styled.i`
	transform: ${(props) => (props.show ? `rotate(0)` : `rotate(180deg)`)};
	transition: transform 0.3s;
`;
